import { useState } from "react";
import { post } from "../services/Services";

export const usePost = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const executePost = async (url, data, config = {}) => {
    setLoading(true);
    try {
      const response = await post(url, data, config);
      return response.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { executePost, error, loading };
};
